export default __webpack_public_path__ + "static/media/logo-mini.4752072a.jpg";